import { useEffect, useMemo, useState } from 'react';

import { useModal } from 'context/ModalContext';

import { ConfirmacaoDaAcao } from './moldura-da-acao';

interface Props {
  callback: (obj: { id: string; message?: string }) => void;
  id: string;
  status: string | undefined;
  data?: any;
  bonus?: boolean;
}

export default function ModalAward(props: Props) {
  const modalID = 'validation-award';

  const { openModal, modalData, closeModal } = useModal();
  const { callback, id } = props;

  const [modalIsOpen, setIsOpen] = useState<boolean>(false);

  const texts = useMemo(() => {
    if (!modalIsOpen) return undefined;

    if (!!modalData?.type && typeof modalData?.type === 'string') {
      if (modalData.type === 'valeu') {
        return {
          title: 'Bonificar "Realização Valeu"',
          description: 'Você pode conceder a Bonificação Valeu para 100% das entregas neste nível.',
        };
      } else if (modalData.type === 'mandou') {
        return {
          title: 'Bonificar "Realização Mandou Bem"',
          description:
            'Você pode conceder a Bonificação Mandou Bem para até 50% (com arredondando para cima) das entregas neste nível.',
        };
      } else if (modalData.type === 'uau') {
        return {
          title: 'Bonificar "Realização UAU"',
          description:
            'Você pode conceder a Bonificação UAU para até 25% (com arredondando para cima) das entregas neste nível, se considerar que a realização é extraordinária para o contexto da Unidade/Diretoria.',
        };
      }
    }

    return undefined;
  }, [modalData, modalIsOpen]);

  useEffect(() => {
    if (typeof id === 'string' && typeof openModal === 'string' && openModal === `${modalID}-${id}`) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [id, openModal]);

  if (!modalIsOpen || typeof modalData?.type !== 'string') return <></>;

  return (
    <ConfirmacaoDaAcao
      title={texts?.title ?? ''}
      onClose={() => closeModal()}
      onConfirm={() => {
        callback({ id: modalData?.type });
        closeModal();
      }}
    >
      <p className="m-0">{texts?.description}</p>
    </ConfirmacaoDaAcao>
  );
}
